<template>
  <div id="notable_developments">
    <div v-if="clock">
      <CountdownClock />
    </div>
    <h1 @click="get_news">Notable Developments</h1>
    <NewsItem v-for="item in displayed_items" v-bind:key="item.index" :news_item="item" />
    <div v-if="more_items">
      <router-link to="/news">More...</router-link>
    </div>
  </div>
</template>

<script>
import NewsItem from "./NewsItem.vue";
import CountdownClock from "@/components/CountdownClock";
const only_get_news_after_ms = 60 * 1000;
const data_source_url = "/api/get_news_feed";

export default {
  name: "NewsItems",
  components: {
    NewsItem,
    CountdownClock
  },
  props: ["external_news_data", "max_items", "clock"],
  data() {
    return {
      news_items: [{ index: 300, News: "...Gettting Latest news..." }],
      news_feed_age: 0,
      news_feed_last_fetch: null
    };
  },
  computed: {
    displayed_items() {
      let result = this.news_items;
      if (this.max_items) {
        result = this.news_items.slice(0, this.max_items);
      }
      return result;
    },
    more_items() {
      if (!this.max_items) {
        return false;
      } else {
        return this.news_items.length > this.max_items;
      }
    }
  },
  created() {
    console.log("Getting New Items...");
    this.get_news();
    console.log("Got New Items...");
  },
  methods: {
    get_news: async function() {
      let data;
      let news_feed_age = Date.now() - this.news_feed_last_fetch;
      let fetch_news_OK =
        news_feed_age !== 0 && news_feed_age > only_get_news_after_ms;
      if (this.news_items.length === 1) {
        fetch_news_OK = true;
      }
      if (!fetch_news_OK) {
        console.log(`Not fetching news: `);
        console.log(`news feed age: ${news_feed_age}`);
        console.log(
          `news feed older than delay: ${news_feed_age >
            only_get_news_after_ms}`
        );
        console.log(`news item count: ${this.news_items.length}`);
        return;
      } else {
        console.log(`FETCHING NEWS: `);
        console.log(`news feed age: ${news_feed_age}`);
        console.log(
          `news feed older than delay: ${news_feed_age >
            only_get_news_after_ms}`
        );
        console.log(`news item count: ${this.news_items.length}`);
      }

      //Allow sending news data as array during initalization
      if (this.external_news_data && this.external_news_data.news_data) {
        data = this.external_news_data;
      } else {
        const response = await fetch(data_source_url, { mode: "no-cors" });
        data = await response.json();
      }
      let news = [];
      if (data.news_data) {
        news = data.news_data.filter(item => {
          return item["News"] && item["News"].length;
        });
        this.news_items = news.reverse();
        this.news_feed_last_fetch = Date.now();
      }
      //reverse the order of the items: newest first
      console.log("updated news items:");
      console.dir(this.news_items);
      console.log("/updated news items");
    }
  }
};
</script>

<style>
h1 {
  font-family: "Archivo Black";
  font-size: 1rem;
  margin-bottom: 1rem;
}
.news_item {
  display: flex;
  justify-self: flex-start;
  justify-content: flex-start;
  grid-template-columns: repeat(12ch, 1fr);
  grid-gap: 10px;
  grid-auto-rows: 100px;
  border-bottom: 3px solid gainsboro;
}
.news_date {
  padding-right: 3ch;
  /*min-width: 12ch; */
}
.news_text {
  display: grid;
  text-align: left;
  justify-content: top;
}
div {
  align-self: start;
}
p {
  border: 3px;
  margin: 0;
  padding: 0;
}
.news_text > p {
  margin: 0;
}
#notable_developments {
  background-color: #d6d6d6;
  background-color: white;
  padding: 1rem;
  font-size: 0.9rem;
  overflow: auto;
  height: 100%;
}
</style>
